export interface IDispenseCours {
  id?: string;
  ecoleId?: string;
  anneeScolaireId?: string;
  classeId?: string;
  classeNom?: string;
  inscriptionId?: string;
  eleveId?: string;
  eleveNom?: string;
  elevePrenom?: string;
  matricule?: string;
  matiereId?: string;
  matiereNom?: string;
  sousMatiereId?: string;
  sousMatiereNom?: string;
  motif?: string;
}

export interface IDispenseCoursBatchRequest {
  ecoleId: string;
  anneeScolaireId: string;
  classeId: string;
  matiereId: string;
  sousMatiereId?: string;
  inscriptionIds: string[];
  motif?: string;
}

export interface IDispenseCoursGroup {
  key: string;
  classeId: string;
  classeNom?: string;
  matiereId: string;
  matiereNom?: string;
  sousMatiereId?: string;
  sousMatiereNom?: string;
  motif?: string;
  motifsMultiples: boolean;
  effectif: number;
  dispenses: IDispenseCours[];
}

export const defaultValue: Readonly<IDispenseCours> = {};
